export default class CoreMenu {
  constructor(parent) {
    this.$parent = parent;
    this.show = true;
    this.logo = '/tourclient/agency/logo';
    this.$items = [
      'dashboard',
      'agreement',
      'finance',
      'search',
      'lead',
      'tourist',
      'partner',
      'task',
      'event',
      'bell',
      'statistic',
      'admin',
    ];
  }

  get items() {
    return this.$items
      .map(i => this[i])
      .filter(i => i);
  }

  get dashboard() {
    return {
      to: '/dashboard',
      icon: 'ul-icon-menu-dashboard',
      label: 'MENU__DASHBOARD',
    };
  }

  get search() {
    const item = {
      to: '/search',
      icon: 'ul-icon-menu-search',
      label: 'MENU__SEARCH',
    };
    return this.$parent.permission.hasAny(191, 192, 193, 194) ? item : null;
  }

  get agreement() {
    const item = {
      to: '/agreement',
      icon: 'ul-icon-menu-agreement',
      label: 'MENU__AGREEMENT',
    };
    return this.$parent.permission.get(183) ? item : null;
  }

  get tourist() {
    const item = {
      to: '/tourist',
      icon: 'ul-icon-menu-tourist',
      label: 'MENU__TOURIST',
    };
    return this.$parent.permission.get(184) ? item : null;
  }

  get lead() {
    const item = {
      to: '/lead',
      icon: 'ul-icon-menu-lead',
      label: 'MENU__LEAD',
    };
    return this.$parent.permission.get(185) ? item : null;
  }

  get finance() {
    const item = {
      to: '/finance',
      icon: 'ul-icon-menu-finance',
      label: 'MENU__FINANCE',
    };
    return this.$parent.permission.get(186) ? item : null;
  }

  get bell() {
    const item = {
      to: '/bell',
      icon: 'ul-icon-menu-bell',
      label: 'MENU__BELL',
    };
    return this.$parent.permission.get(218) ? item : null;
  }

  get statistic() {
    const item = {
      to: '/statistic',
      icon: 'ul-icon-menu-statistic',
      label: 'MENU__STATISTIC',
    };
    return this.$parent.permission.get(152) ? item : null;
  }

  get task() {
    const item = {
      to: '/task',
      icon: 'ul-icon-menu-task',
      label: 'MENU__TASK',
    };
    return this.$parent.permission.get(187) ? item : null;
  }

  get event() {
    const item = {
      to: '/event',
      icon: 'ul-icon-menu-event',
      label: 'MENU__EVENT',
    };
    return this.$parent.permission.get(190) ? item : null;
  }

  get partner() {
    const item = {
      to: '/partner',
      icon: 'ul-icon-menu-partner',
      label: 'MENU__PARTNER',
    };
    return this.$parent.permission.get(188) ? item : null;
  }

  get admin() {
    const item = {
      to: '/admin',
      icon: 'ul-icon-menu-admin',
      label: 'MENU__ADMIN',
    };
    return this.$parent.permission.hasAny(1, 4, 8, 9, 46, 52, 113, 124, 166, 167)
      ? item
      : null;
  }

  logout() {
    this.$parent.account
      .logOut()
      .finally(() => {
        this.$parent.router.push('/authentication');
      });
  }
}
